import axios from 'axios'
import { Auth } from 'aws-amplify'
import { t } from '@/i18n'
import { newRequestKey } from './billing'
import { creditsChanged } from './ai'
import { showResourceError } from './resources'

const client = axios.create({ baseURL: process.env.VUE_APP_ROOT_API, timeout: 30000 })
const pending = new Map()
async function context() {
  const session = await Auth.currentSession()

  return { subject: session.getAccessToken().payload.sub, headers: { Authorization: session.getAccessToken().getJwtToken() } }
}
export async function animationOptions(fileId, sourceVersion) {
  const auth = await context()
  const { data } = await client.get('/ai/animations', {
    headers: auth.headers, params: { files_link_id: fileId, source_version: sourceVersion },
  })

  return data
}
export async function animationStatus(id) {
  const auth = await context()

  return (await client.get(`/ai/animations/${encodeURIComponent(id)}`, { headers: auth.headers })).data
}
export async function createAnimation(payload, retryJobId = '') {
  const auth = await context()
  const key = `photo-animation:${auth.subject}:${payload.files_link_id}:${payload.source_version}:${payload.model}${retryJobId ? `:retry:${retryJobId}` : ''}`
  let state = pending.get(key)
  try { state = state || JSON.parse(sessionStorage.getItem(key)) } catch (_) { /* Storage can be disabled. */ }
  if (!state) state = { requestKey: newRequestKey(), payload }
  pending.set(key, state)
  try { sessionStorage.setItem(key, JSON.stringify(state)) } catch (_) { /* Keep the in-memory retry. */ }
  const clear = () => {
    pending.delete(key)
    try { sessionStorage.removeItem(key) } catch (_) { /* Keep working without storage. */ }
  }
  try {
    const { data } = await client.post('/ai/animations', state.payload, {
      headers: { ...auth.headers, 'Idempotency-Key': state.requestKey },
    })
    clear()
    creditsChanged()

    return data
  } catch (error) {
    if (error.response && [400, 401, 402, 403, 404, 409, 413, 422, 429].includes(error.response.status)) clear()
    if (error.response && ['INSUFFICIENT_CREDITS', 'STORAGE_LIMIT_EXCEEDED'].includes(error.response.data.error)) showResourceError(error)
    throw error
  }
}
